// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Home from './pages/Home';
import Login from './components/PatientLogin';
import PatientForgotPassword from './components/PatientForgotPassword';
import DoctorForgotPassword from './components/DoctorForgotPassword';
import ResetPassword from './components/ResetPassword';
import Register from './pages/Register';
import Search from './pages/Search';
import OurServices from './pages/OurServices';
import About from './pages/About';
import ShivendraJha from './pages/ShivendraJha';
import Contact from './pages/Contact';
import FAQs from './pages/FAQs';
import Footer from './components/Footer';
import PatientRegister from './components/PatientRegister';
import PatientDashboard from './components/PatientDashboard';
import SearchDoctor from './components/SearchDoctor';
import PatientProfile from './components/PatientProfile';
import BookAppointment from './components/BookAppointment';
import ReviewPage from './components/ReviewPage';
import AppointmentBooked from './components/AppointmentBooked';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentFailed from './components/PaymentFailed';
import EditProfile from './components/EditProfile';
import PatientVideoCall from './components/PatientVideoCall';
import FeedbackSuccess from './components/FeedbackSuccess';
import SymptomChecker from './components/SymptomChecker';
import PatientFeedback from './components/PatientFeedback';
import FindDoctor from './pages/FindDoctor';
import ViewRecords from './components/ViewRecords';
import PatientAppointments from './components/PatientAppointments';
import AppointmentDetailView from './components/AppointmentDetailView';
import Support from './pages/Support';
import DoctorLogin from './components/DoctorLogin';
import DoctorRegister from './components/DoctorRegister';
import DoctorDashboard from './components/DoctorDashboard';
import DoctorProfile from './components/DoctorProfile';
import DoctorAppointments from './components/DoctorAppointments';
import DoctorEarnings from './components/DoctorEarnings';
import PatientRecords from './components/PatientRecords';
import DoctorPatients from './components/DoctorPatients';
import DoctorStartVideoConsultation from './components/DoctorStartVideoConsultation';
import DoctorVideoCall from './components/DoctorVideoCall';
import DoctorPrescription from './components/DoctorPrescription';
import PrescriptionSuccess from './components/PrescriptionSuccess';
import DoctorFeedback from './components/DoctorFeedback';
import AdminPage from './admin/AdminPage';
import AdminAppointmentDetailView from './admin/components/AdminAppointmentDetailView';

const App = () => {
  const patientId = localStorage.getItem('patientId');

  return (
    <Router>
      <AuthProvider>
        <div className="app-container">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/patient/forgot-password" element={<PatientForgotPassword />} />
            <Route path="/doctor/forgot-password" element={<DoctorForgotPassword />} />
            <Route path="/reset-password/:role/:token" element={<ResetPassword />} />
            <Route path="/search" element={<Search />} />
            <Route
              path="/book-appointment"
              element={<BookAppointment patientId={patientId} />}
            />
            <Route path="/review-appointment" element={<ReviewPage />} />
            <Route path="/appointment-booked" element={<AppointmentBooked />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-failed" element={<PaymentFailed />} />
            <Route path="/services" element={<OurServices />} />
            <Route path="/about" element={<About />} />
            <Route path="/shivendra-jha" element={<ShivendraJha />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQs />} />
            <Route path="/patient-register" element={<PatientRegister />} />
            <Route path="/patient-dashboard/:patientId" element={<PatientDashboard />} />
            <Route path="/patient/appointments/:appointmentId" element={<AppointmentDetailView />} />
            <Route path="/search-doctor" element={<SearchDoctor />} />
            <Route path="/patient-profile" element={<PatientProfile />} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/patient/video-call/:appointmentId" element={<PatientVideoCall />} />
            <Route path="/feedback-success" element={<FeedbackSuccess />} />
            <Route path="/symptom-checker" element={<SymptomChecker />} />
            <Route path="/patient/feedback/:appointmentId" element={<PatientFeedback />} />
            <Route path="/find-doctor" element={<FindDoctor />} />
            <Route path="/patient/view-records" element={<ViewRecords />} />
            <Route path="/patient/appointments" element={<PatientAppointments />} />
            <Route path="/patient/appointment-detail/:appointmentId" element={<AppointmentDetailView />} />
            <Route path="/support" element={<Support />} />
            <Route path="/doctor-login" element={<DoctorLogin />} />
            <Route path="/doctor-register" element={<DoctorRegister />} />
            <Route path="/doctor-dashboard/:userid" element={<DoctorDashboard />} />
            <Route path="/doctor-profile" element={<DoctorProfile />} />
            <Route path="/doctor-appointments" element={<DoctorAppointments />} />
            <Route path="/doctor/patient-records/:patientId" element={<PatientRecords />} />
            <Route path="/doctor-patients" element={<DoctorPatients />} />
            <Route path="/doctor-video-consultation" element={<DoctorStartVideoConsultation />} />
            <Route path="/doctor/video-call/:appointmentId" element={<DoctorVideoCall />} />
            <Route path="/doctor/prescription/:appointmentId" element={<DoctorPrescription />} />
            <Route path="/prescription-success" element={<PrescriptionSuccess />} />
            <Route path="/doctor-earnings" element={<DoctorEarnings />} />
            <Route path="/doctor-messages" element={<div>Messages Page</div>} />
            <Route path="/doctor/feedback" element={<DoctorFeedback />} />
            <Route path="/doctor-settings" element={<div>Settings Page</div>} />
            <Route path="/admin/*" element={<AdminPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/appointments/:appointmentId" element={<AdminAppointmentDetailView />} />
            <Route path="*" element={<div>404 - Page Not Found</div>} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
};

export default App;